export const css = {
	root: '_3gYYteZN',
	linear: '_2_Gs28MU',
	circular: 'iRZM72I6',
	spin: '_21o8cHkN',
	inactive: '_1vGJM41t',
	buffer: '_1hCUf_Oj',
	bar: 'yol4inw-',
	primary: 'MvGT-igZ',
	progress: '_3Gx12-Ut',
	inner: '_2k0ojoHY',
	small: '_2xj5MUel',
	medium: '_3c0AZQ84',
	large: 't8a2dqz3',
	' _key': 'certwise-theme/dojo/loading-indicator'
};

export default css;
